// actions
import dayjs from 'dayjs';
import { ENTRY_SLICE_NAME } from '../actions/entry.action';
import {
  IAttendanceSummary,
  IDailyEntryRecord,
  IEntry,
  IEntryMeta,
  IEntryStatics,
  IEntryWeekly,
  ReqEntries
} from '../models/entry.model';

// thunks
import {
  getEntries,
  getEntryHistoryUser,
  getEntryStatistics,
  getEntryStatisticsWeekly
} from '../thunks/entry.thunk';

// libraries
import { createSlice } from '@reduxjs/toolkit';
import { dateToString } from 'utils';
import { TotalMapProps } from 'modules/common';
import { DEFAULT_PAGE, DEFAULT_PAGE_SIZE } from 'constants/const';
export interface EntryState {
  // User Info
  entryList: IDailyEntryRecord[];
  entryTotal: IAttendanceSummary;
  entryTotalEl: number;

  // Site Entry Management
  entryStatistics: IEntryStatics[];
  entryStatisticsWeekly: IEntryWeekly[];
  entries: IEntry[];
  entriesTotalMap: TotalMapProps;
  entryMeta: IEntryMeta;
  fetchEntriesRequest: ReqEntries;
}

const initialState: EntryState = {
  // User Info
  entryList: [],
  entryTotal: {
    mobilization: '',
    cumulativeEntry: 0,
    thisMonthEntry: 0
  },
  entryTotalEl: 0,

  // Site Entry Management
  entryStatistics: [],
  entryStatisticsWeekly: [],
  entries: [],
  entriesTotalMap: {
    totalElements: 0,
    totalPages: 0
  },
  entryMeta: {
    total: 0,
    in: 0,
    out: 0
  },
  fetchEntriesRequest: {
    entryDate: dateToString(dayjs().toDate()),
    companyId: '',
    workerType: '',
    status: '',
    keyword: '',
    page: DEFAULT_PAGE,
    size: DEFAULT_PAGE_SIZE
  }
};

const entrySlice = createSlice({
  name: ENTRY_SLICE_NAME,
  initialState,
  reducers: {
    changeFetchEntriesRequest: (state, action) => {
      state.fetchEntriesRequest = {
        ...state.fetchEntriesRequest,
        ...action.payload
      };
    },
    resetAll: () => initialState
  },
  extraReducers: (builder) => {
    builder
      .addCase(getEntryHistoryUser.fulfilled, (state, action) => {
        const { resultList, resultObject, totalMap } = action.payload;

        state.entryList = resultList || [];
        state.entryTotal = resultObject;
        state.entryTotalEl = totalMap.totalElements;
      })

      .addCase(getEntryStatistics.fulfilled, (state, action) => {
        state.entryStatistics = action.payload.resultList;
      })

      .addCase(getEntryStatisticsWeekly.fulfilled, (state, action) => {
        state.entryStatisticsWeekly = action.payload.resultList;
      })

      .addCase(getEntries.fulfilled, (state, action) => {
        const { resultObject, resultList, totalMap } = action.payload;
        state.entryMeta = resultObject;
        state.entries = resultList;
        state.entriesTotalMap = totalMap;
      });
  }
});

export const entry = entrySlice.name;
export const entryReducer = entrySlice.reducer;
export const entryActions = entrySlice.actions;
export const { changeFetchEntriesRequest, resetAll } = entrySlice.actions;
export default entrySlice.reducer;
